<!--
 * @Author: Tommy Chen weiyao_85@163.com
 * @Date: 2025-01-23 16:37:22
 * @LastEditors: Tommy Chen weiyao_85@163.com
 * @LastEditTime: 2025-06-22 10:23:43
 * @FilePath: /help.center.intl/src/views/Home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <Introduce />
    <Categories />
    <!-- 返回旧版 -->
    <!-- <div class="backlog">
      <a href="/wiki" style="color: var(--text-secondary)">
      <p>Back to Old Version</p></a>
    </div> -->
  </div>
</template>

<script>
import Introduce from "@/views/introduce.vue";
import Categories from "@/views/categories.vue";

export default {
  name: "Home",
  components: {
    Introduce,
    Categories,
  },
  mounted() {
   
  },
  data() {
    return {
      system: process.env.VUE_APP_SYS,
    };
  },
  methods:{
  }
};
</script>
<style scoped>
.backlog {
  position: fixed;
  z-index: 999;
  width: 38px;
  padding: 8px;
  height: 104px;
  background: var(--bg-dialog);
  right: 0;
  top: 50%;
  border-style: solid;
  border-color: var(--gray-4);
  /* 弹窗阴影 */
  box-shadow: 0px 2px 8px var(--shadow-1);
  border-radius: 4px 0px 0px 4px;
  font-weight: 400;
font-size: 14px;
line-height: 22px;
}
</style>
